import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeView',
    setup(__props) {
        const router = useRouter();
        function goToAbout() {
            router.push('/about');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _cache[0] || (_cache[0] = _createElementVNode("h2", null, "HomeView", -1)),
                _createElementVNode("button", { onClick: goToAbout }, "Go to About")
            ], 64));
        };
    }
});
